import { render, staticRenderFns } from "./ItemsCrudList.vue?vue&type=template&id=79125fcd&scoped=true&"
import script from "./ItemsCrudList.vue?vue&type=script&lang=js&"
export * from "./ItemsCrudList.vue?vue&type=script&lang=js&"
import style0 from "./ItemsCrudList.vue?vue&type=style&index=0&id=79125fcd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79125fcd",
  null
  
)

export default component.exports